import React from 'react';
import { motion } from 'framer-motion';

export default function SectionLabel({ children, className = '' }) {
  return (
    <motion.span
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className={`inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#00D4FF] font-syne mb-4 ${className}`}
    >
      {children}
    </motion.span>
  );
}
